import React from 'react';
import { LinearProgress } from '@bb-ui/react-library';
import { JobExecutionTable } from 'components/JobExecutionList';
import { useJobRegion } from 'contexts/JobRegionContext';
import { RefreshOnNavigate } from './RefreshOnNavigate';

export const TenantJobExecutions: React.FC = () => {
  const { isJobRegionReady } = useJobRegion();
  if (!isJobRegionReady) return <LinearProgress ariaLabel="Loading Job Executions" />;
  return <RefreshOnNavigate content={<JobExecutionTable />} />;
};
